import { z } from 'zod';

export const appSettingsSchema = z.object({
  enableAbsenceDecisionSupport: z.boolean().default(true),
  enableAdminKpiDashboard: z.boolean().default(true),
  defaultAnnualVacationDays: z.number().int().min(0).max(100).default(30),
  absenceWarningThresholdDays: z.number().int().min(1).max(30).default(5),
});

export type AppSettingsInput = z.infer<typeof appSettingsSchema>;
